import { AlertTriangle } from "lucide-react";
import { isProd } from "../utils/env";

export default function DevelopmentBanner() {
  if (isProd()) {
    return null;
  }

  return (
    <div className="bg-red-600 text-white py-2 px-4 text-center font-semibold shadow-lg sticky top-0 z-[60]">
      <div className="flex items-center justify-center gap-2">
        <AlertTriangle className="h-5 w-5" />
        <span>DEVELOPMENT ENVIRONMENT - Don't add real data</span>
        <AlertTriangle className="h-5 w-5" />
      </div>
    </div>
  );
}
